import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import { ReduceStore } from 'flux/utils';
import update from 'immutability-helper';

const sanitize = (entity) => ({
    ...entity
});

const getEmptyState = (isFetching = false) => ({
    isFetching,
    events: {},
    byLocation: {}
});

const normalise = (source, idField = 'id') => {
    let data = {}, ids = [];
    source.forEach((row) => {
        const id = row[idField];
        data[id] = row;
        ids.push(id);
    });
    return { data, ids };
};

class LocationEventStore extends ReduceStore {

    getInitialState() {
        return getEmptyState();
    }

    isFetching() {
        return this.getState().isFetching;
    }

    getByLocation(locationId) {
        return Object.values(this.getState().events).filter(le => (le !== undefined && le.locationId === locationId));
    }

    getById(id) {
        return Object.values(this.getState().events).find(le => (le !== undefined && le.id === id));
    }

    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.LOCATION_EVENT_LIST_REQUEST:
                return update(this.getState(), { isFetching: { $set: true }});

            case ActionTypes.LOCATION_EVENT_LIST_SUCCESS:
                const { data, ids } = normalise(action.data);

                return update(this.getState(), {
                    isFetching: { $set: false },
                    events: { $merge: data },
                });

            case ActionTypes.LOCATION_EVENT_LIST_FAILURE:
                return update(this.getState(), { isFetching: { $set: false }});

            default:
                return state;
        }
    }
}

export default new LocationEventStore(CentricDispatcher);
